import React, { useState } from "react";
import axios  from "axios";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Android_and_iOS from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Android_and_iOS.svg";
import Blockchain from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Blockchain-Based.svg";
import Cross from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Cross-Platform_Poker.svg";
import Immersive_Game_Design from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Immersive_Game_Design.svg";
import Poker_Website from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Poker_Website.svg";
import Turnkey_Poker from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Turnkey_Poker.svg";
import Verified_Randomness1 from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Verified_Randomness-1.svg";
import Verified_Randomness from "../../../assets/Services/Poker_Game_Dev/Poker_Game_Development/Verified_Randomness.svg";

import Deployment_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Deployment_&_Maintenance.svg";
import Design_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Design_&_Prototyping.svg";
import GameDevelopment from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg";
import Requirement_Analysis from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Requirement_Analysis.svg";
import Testing_ from "../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Testing_&_Quality.svg";

import Analytics_ from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Analytics_&_Monitoring.svg";
import APIs_ from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/APIs_&_Integrations.svg";
import Backend from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Backend.svg";
import Cloud_ from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Cloud_&_Hosting.svg";
import Frontend from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Frontend.svg";
import Testing_Tools from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Testing_Tools.svg";
import Databases from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/Databases.svg";
import DevOps_ from "../../../assets/Services/Poker_Game_Dev/The_Raiden_Edge/DevOps_&_CI.svg";

import Casino_Game_Development from "../../../assets/Services/Board_game_Dev/Casino_Game_Development.png";

import Maskss from "../../../assets/Services/Poker_Game_Dev/Profile_pic/Maskgroup-1.png";
import Mask2 from "../../../assets/Services/Poker_Game_Dev/Profile_pic/Maskgroup-2.png";
import Mask3 from "../../../assets/Services/Poker_Game_Dev/Profile_pic/Maskgroup.png";

import Anti_fraud_1 from "../../../assets/Services/Poker_Game_Dev/Anti_fraud_1/Anti_fraud_1.png";
import Anti_fraud_2 from "../../../assets/Services/Poker_Game_Dev/Anti_fraud_1/Anti_fraud_2.png";

import Fortified_transaction_1 from "../../../assets/Services/Poker_Game_Dev/Fortified_transaction_1/Fortified_transaction_1.png";
import Fortified_transaction_2 from "../../../assets/Services/Poker_Game_Dev/Fortified_transaction_1/Fortified_transaction_2.png";

import Pioneering_customization_1 from "../../../assets/Services/Poker_Game_Dev/Pioneering_customization_1/Pioneering_customization_1.png";
import Pioneering_customization_2 from "../../../assets/Services/Poker_Game_Dev/Pioneering_customization_1/Pioneering_customization_2.png";

import Real_time_engagement_1 from "../../../assets/Services/Poker_Game_Dev/Real_time_engagement_1/Real_time_engagement_1.png";
import Real_time_engagement_2 from "../../../assets/Services/Poker_Game_Dev/Real_time_engagement_1/Real_time_engagement_2.png";

import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";

import Access_to_Distinguished_Expertise from "../../../assets/Services/Board_game_Dev/Exp_raiden/Access_to_Distinguished_Expertise.svg";
import Advanced_Technology_Implementation from "../../../assets/Services/Board_game_Dev/Exp_raiden/Advanced_Technology_Implementation.svg";
import Complete_regional_adaptation from "../../../assets/Services/Board_game_Dev/Exp_raiden/Complete_regional_adaptation.svg";
import Expert_Consultation_on_Strategic_Issues from "../../../assets/Services/Board_game_Dev/Exp_raiden/Expert_Consultation_on_Strategic_Issues.svg";
import Pioneering_Game from "../../../assets/Services/Board_game_Dev/Exp_raiden/Pioneering_Game-play_Innovation.svg";

import icon1 from "../../../assets/Services/Game_page/poker/icon1.png";
import icon2 from "../../../assets/Services/Game_page/poker/icon2.png";
import icon3 from "../../../assets/Services/Game_page/poker/icon3.png";

import img from "../../../assets/Services/Poker_Game_Dev/double_img/img1.svg";
import img2 from "../../../assets/Services/Poker_Game_Dev/double_img/img2.png";
import img3 from "../../../assets/Services/Poker_Game_Dev/double_img/img3.svg";
import img4 from "../../../assets/Services/Poker_Game_Dev/double_img/img4.svg";
import img5 from "../../../assets/Services/Poker_Game_Dev/double_img/img5.svg";
import FaqHome from "../../../components/faq/FaqHome";
import Conatct from "../features/miscellaneous/contact";
import Contact from "../features/miscellaneous/contact";

const PokerGameDevelopment = () => {
 

  const cards = [
    {
      title: "Real-Time Engagement & Intelligence",
      desc: "We create poker platforms with dependable, real-time multiplayer functionality so that every player can play with ease. Our systems give you real-time data to manage and improve your operations while also offering comprehensive analytics and live game insights.",
      img: img,
    },
    {
      title: "Fortified Transactions",
      desc: "Our development ensures safe transactions and a trustworthy peer-to-peer gaming environment by integrating cutting-edge anti-fraud and fair play systems with top secure payment gateways.",
      img: img2,
    },
    {
      title: "Pioneering Customization & Ownership",
      desc: "Our customized poker solutions use blockchain, AI, NFTs, multi-currency support, and modern digital assets to create engaging experiences. We guarantee that your vision is realized with unmatched control by offering professional advice, complete code ownership, and transparent project execution.",
      img: img3,
    },
    {
      title: "Anti-fraud and fair play systems",
      desc: "We engineer robust anti-fraud systems and advanced security protocols into every game. With ongoing monitoring and seamless integration of all major payment gateways (including multi-currency and crypto wallet support like MetaMask), we guarantee a trustworthy, safe, and truly fair peer-to-peer environment.",
      img: img4,
    },
    {
      title: "Digital Assets and Multi-Currency Support",
      desc: "Enjoy flawless multiplayer functionality in real time, which guarantees incredibly fluid gameplay for all users. You get instant access to vital information that you can use to maximize player engagement and performance when combined with thorough live game insights and analytics.",
      img: img5,
    },
  ];
  const pokerdevcompany2 = [
    {
      title: "  Pioneering Game-play Innovation ",
      icon: Pioneering_Game,
      desc: "Raiden prefers uniqueness in creativity when it comes to game design. We actively work to add interesting features and innovative mechanics. This dedication to uniqueness sets our product apart and improves the overall gaming experience, encouraging long-term user involvement.   ",
    },
    {
      title: "  Advanced Technology Implementation ",
      icon: Advanced_Technology_Implementation,
      desc: " We take advantage of modern technological innovations, like safe digital asset management, innovative gaming capabilities, and dependable, scalable real-time infrastructure, to ensure peak performance and future adaptability.  ",
    },
    {
      title: " Comprehensive Regional Adaptation ",
      icon: Complete_regional_adaptation,
      desc: "Our approach combines subtle localization—regionally relevant payment methods, culturally sensitive design, and extensive multilingual support—to make sure your game has a significant impact on a wide range of international player communities.   ",
    },
    {
      title: "Expert Consultation on Strategic Issues   ",
      icon: Expert_Consultation_on_Strategic_Issues,
      desc: "As the project progresses from conception to market launch, we offer crucial strategic direction. Our skilled consultants make sure your project complies with current industry norms and is positioned to optimize its competitiveness.   ",
    },
    {
      title: "  Access to Distinguished Expertise ",
      icon: Access_to_Distinguished_Expertise,
      desc: "Our professionals can produce a polished, reliable, and market-ready unity game with accuracy and efficiency because they have a wealth of knowledge and specialized skills.   ",
    },
  ];

  const pokerdevcompany = [
    {
      title: "Requirement Analysis",
      icon: Requirement_Analysis,
      desc: "Here at Raiden Labs, we take a deep dive into client goals, challenges, and needs at the beginning of each project. Our process includes really digging deep into the client's unique needs, target, and overall strategic goals. By precisely scoping the project, we take steps to guarantee the branded poker game is a perfect fit with the client’s brand and market position from the word go.",
    },
    {
      title: "Design & Prototyping ",
      icon: Design_,
      desc: "Our process in designing includes effective wireframes with constant updates. We seamlessly build, design, and improve the design according to your custom business needs. We are making certain that all devices, including phones, tablets, and desktop computers, operate as intended. Interfaces that are logical and captivate players not only by appearances but also by the way everything functions as a whole.",
    },
    {
      title: "Game Development",
      icon: GameDevelopment,
      desc: "Raiden uses advanced frameworks that turn poker concepts into realistic, playable experiences. We engage multiplayer chats and high-efficiency graphics for producing a perfect and engaging gaming experience, giving players a well-executed experience rather than a shoddy one.",
    },
    {
      title: "Testing & Quality Assurance",
      icon: Testing_,
      desc: "we take quality control extremely seriously. All builds undergo comprehensive testing for security, usability, and functionality. Consider penetration tests, manual QA, automated test suites, and so forth. Before anyone else can even notice a flaw, we fix it. A poker game that functions flawlessly, withstands stress, and doesn't have any serious flaws.",
    },
    {
      title: "Deployment & Maintenance",
      icon: Deployment_,
      desc: "Raiden oversees the entire deployment process after development is complete. We take care of server configurations, platform integrations, and any technical issues that may arise during launch. After launch, we're not merely waiting around; we're actively monitoring, patching, resolving issues, and releasing new features as required. To ensure that players always have the best possible experience, the game is kept stable, secure, and relevant through regular maintenance.",
    },
  ];

  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon: Arcade_Game_Development,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Casino Game Development  ",
      icon: Casino_Game_Development,
      desc: " Deliver immersive casino classics—from slots to roulette and blackjack—integrated with secure wallets, tournament systems, live dealer support, and multilingual functionality, all within a compliance-ready framework.",
      link: "/casino-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon: Rummy_Game_Development,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon: Immersive_Game_Design,
      title: "Immersive Game Design",
      desc: "Our specialty at Raiden, is turning poker ideas into visually stunning, technically sound products. Whether you want engaging 3D environments or classic 2D interfaces, our team develops precise implementations that balance performance and aesthetics. ",
    },
    {
      icon: Cross,
      title: "Cross-Platform Poker App Development  ",
      desc: "Maximize your audience with our cross-platform expertise. Our developers make sure that your poker game functions consistently across all major operating systems, giving players consistent access and stable performance on any device. ",
    },
    {
      icon: Android_and_iOS,
      title: "Android and iOS Poker Game",
      desc: "Raiden creates poker apps that are optimized for iOS and Android, taking into consideration the particular needs of each platform and offering top-notch performance on all compatible devices. ",
    },
    {
      icon: Turnkey_Poker,
      title: "Turnkey Poker Solutions  ",
      desc: "We manage every technical aspect—from backend infrastructure to front-end design—freeing you up to focus on operations and growth. It’s the most efficient way to get your poker platform to market. ",
    },

    {
      icon: Poker_Website,
      title: "Poker Website Development",
      desc: "We design unique poker websites that offer safe, easy-to-use experiences in addition to a sleek aesthetic. Our web solutions are made to support your brand and give each player a smooth experience. ",
    },
    {
      icon: Blockchain,
      title: "Blockchain-Based Poker Games  ",
      desc: "We add transparency features, secure cryptocurrency payments, and blockchain technology to your poker platform. Our experience guarantees that your game remains innovative, providing players with fairness, trust, and a genuinely contemporary poker experience. ",
    },
    {
      icon: Verified_Randomness1,
      title: "Verified Randomness ",
      desc: "At Raiden, being open is a commitment rather than merely a motto. Considering that our Random Number Generation (RNG) is independently audited, players can always rely on unpredictable, fair results. Trust is the cornerstone of our services. ",
    },
    {
      icon: Verified_Randomness,
      title: "Modern Video Poker",
      desc: "Our objective is to update the traditional video poker game for today's online players. Raiden creates captivating events that entice players to return by fusing the classic charm of gameplay with cutting-edge new features. ",
    },
  ];

  const clientexp = [
    {
      icon: Maskss,
      name: "Liam O'Connell ",

      desc: "Collaborating with Raiden Labs was a pivotal upgrade for our organization’s tech stack. Their poker development team quickly understood our core requirements and delivered a solution that went beyond our specs. Implementation was quick—no bottlenecks, no runarounds—just solid project management from end to end. It’s tough to find dev partners with real domain expertise in poker, but Raiden Labs stood out. If you need reliable poker game development, they’re the ones to call.  ",
    },
    {
      icon: Mask2,
      name: " Mateo Ramirez ",
      undername: " ",
      desc: "  We needed a partner who could design and implement a strong, unique poker solution; we weren't interested in off-the-shelf features. The Raiden Labs team carried out a smooth rollout and offered practical suggestions. Player engagement metrics are up, satisfaction is trending positive, and the backend is rock solid. Choosing Raiden Labs was a strategic win for us.",
    },
    {
      icon: Mask3,
      name: "Marco Rossi",
      undername: "  ",
      desc: " Raiden Labs delivered serious results. Their team designed a total modernization of our antiquated legacy poker platform. They demonstrated technical proficiency throughout development by meeting deadlines, communicating effectively, and keeping a laser-like focus on quality control. The outcome was a gaming platform that was scalable and precisely suited to our present and future requirements. Highly recommend for any technical organization seeking proven poker development expertise. ",
    },
  ];
  
  

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div
        className="container  marb d-flex   align-items-center topheader-margin"
        style={{ minHeight: "100vh" }}
      >
        <div
          className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"
          style={{ minHeight: "100vh" }}
        >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">Poker Game Development</h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs has been successful in the game development industry for over 10 years, creating immersive gaming environments for
              enjoyable activities and unforgettable technologies
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Schedule a Free Demo
              </button>
            </Link>
          </div>
          <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={icon1} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Developing Poker Games and Innovating Excellence
            </h2>
            <p className="mt-4  h1-para" >
              Raiden has over 10 years of experience developing software, and
              with its  feature-rich, personalized, professional-grade PC,
              mobile, and web-based poker solutions, they can make your unique
              idea a reality. Our user-friendly environments, player-first
              features, military-grade security, and up-to-date real-time
              technology all keep players coming back for more. With Raiden Labs
              you’ll own and have clear insight into the development, and the
              addition of modern technologies like blockchain and NFTs will make
              your poker game the most innovative on the digital platform.
            </p>
            <ul className="mt-2 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Professional advice for game complexities
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Full ownership of code and Custom software
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Seamless execution and transparent updates
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart  text-center">
        <h2 className="h2-heading lh-base ">
          Features of Poker Game and its Development
        </h2>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Poker Game Development Services
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            As a leading game development company, we create games that support
            all platforms, and we integrate games with blockchain technology
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row d-flex justify-content-center align-items-center ">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                Our actions in the advancement of poker
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                At Raiden Labs, we specialize in delivering robust poker games
                tailored to your needs. Whether it’s classic 2D, immersive 3D,
                or engaging video poker, our team develops games for any device.
                Each product comes packed with advanced features and secure
                digital assets—so you get fair play and rock-solid security
                every step of the way. From the initial idea to a full launch,
                we handle the entire process and provide full ownership, turning
                your poker vision into a reality without compromise.
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                  Schedule a demo call
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon2} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and  Flawless Poker.
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge poker gameplay  experience.
          </p>
          <CoreComponent32 />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Poker: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs’ platform’s real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your poker app stays stable and usable, boosting user
              engagement on all platforms
            </p>
            <CoreComponent37 />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart">
        <div className="container p-4">
          <div className="row d-flex justify-content-center align-items-center ">
            <div className="col-lg-6">
              <h2 className="h2-heading text-start  mb-2 fs-3 text-white mb-lg-3">
                Are you looking for the ideal poker software development
                solution for gameplay?
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                The Technological Advantage of Raiden Labs: the Better Poker
                software development company.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon3} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart text-center">
        <h2 className="h2-heading lh-base mb-3">
          Experience Raiden’s Poker Game Development
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-sm h2-heading ">
          The Development Process of Our Poker Games
        </h2>
        <p className="my-3 fs-6 mx-lg-4 h1-para   text-center">
          We always strive for technological advances and steady development for
          our personalized poker platforms. Our solutions are purpose-built to
          prioritize rock-solid security and scale, with a user experience that
          keeps your users engaged with tasteful interfaces and functionality.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 h1-para pb-2">
          How our Poker game development has changed the business directly here
          from clients' experience and results, by partnering with us in their
          Poker game development journey
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PokerGameDevelopment;
